<template>
  <base-material-card
    color="primary"
    icon="mdi-chart-multiple"
    title="Adicionar Analítico de CA"
    inline
    class="px-5 py-4 ml-0"
  >
    <v-form class="mt-5">
      <v-row align="center" class="mx-auto">
        <v-col cols="12">
           <v-textarea
            id="obras-analitico-ca"
            class="pt-0 mt-0"
            label="Obras"
            v-model="obras"
            placeholder="Insira os códigos das obras, um por linha. Ex.:

CI1944457111 
CI1944457348"
            rows="5"
            no-resize
            clearable
            clear-icon="mdi-close-circle"
          />
        </v-col>
      </v-row>

      <v-row align="center" class="mx-auto">
        <v-col cols="12">
           <v-textarea
            id="tipologias-analitico-ca"
            class="pt-0 mt-0"
            label="Tipologias"
            v-model="tipologias"
            placeholder="Insira os códigos das tipologias, um código por linha. Ex.: 

RAU
RAR"
            rows="5"
            no-resize
            clearable
            clear-icon="mdi-close-circle"
          />
        </v-col>
      </v-row>

      <v-row class="mx-auto" id="data-imobilizacao-analitico-ca" justify="space-between">
        <v-col class="pb-0 pt-1 pl-2" cols="12" sm="5">
          <v-menu
            v-model="menuPickerImob[0]"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider 
                v-slot="{ errors }"
                :rules="{ required_if: dataImob.fimFormatted != null && dataImob.fimFormatted.length > 0, min:10 }"
              >
                <v-text-field
                  :error-messages="errors"
                  class="pt-0"
                  v-mask="'##/##/####'"
                  v-model="dataImob.inicioFormatted"
                  label="Data Imobilização"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-bind="attrs" v-on="on"
                  @blur="dataImob.inicio = parseDate(dataImob.inicioFormatted);"
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="dataImob.inicio"
              @input="menuPickerImob[0] = false; dataImob.inicioFormatted = formatDate(dataImob.inicio);"
              locale="pt-br"
            />
          </v-menu>
        </v-col>
        <v-col class="text-center pt-5" style="min-width:60px !important;" cols="12" sm="1">
          <span style="color: rgba(0, 0, 0, 0.54); font-size:15px">até</span> 
        </v-col>
        <v-col class="pb-0 pt-1 pl-2" cols="12" sm="5">
          <v-menu
            v-model="menuPickerImob[1]"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider 
                v-slot="{ errors }" 
                :rules="{ required_if: dataImob.inicioFormatted != null && dataImob.inicioFormatted.length > 0, min:10 }"
              >
                <v-text-field
                  :error-messages="errors"
                  class="pt-0"
                  v-mask="'##/##/####'"
                  v-model="dataImob.fimFormatted"
                  label="Data Imobilização"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-bind="attrs" v-on="on"
                  @blur="dataImob.fim = parseDate(dataImob.fimFormatted);"
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="dataImob.fim"
              @input="menuPickerImob[1] = false; dataImob.fimFormatted = formatDate(dataImob.fim);"
              locale="pt-br"
            />
          </v-menu>
        </v-col>
      </v-row>

      <v-row class="mx-auto" id="flags-analitico-ca" justify="space-between">
        <v-col cols="12" sm="5">
          <v-select
            :items="flagsValueList"
            hide-details
            v-model="flag1"
            label="Flag 1: Obra com UAR <= 10%"
          />
        </v-col>

        <v-col cols="12" sm="5">
          <v-select
            :items="flagsValueList"
            hide-details
            v-model="flag2"
            label="Flag 2: Flag 90"
          />
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>

import DateFormatterMixins from "@/mixins/dateFormatterMixins.js";

export default {
  name: "ParametrosAnaliticosCA",

  mixins: [DateFormatterMixins],
  
  data() {
    return {
      obras: "",
      tipologias: "",
      dataImob: {
        inicioFormatted: '',
        inicio: '',
        fimFormatted: '',
        fim: '',
      },
      menuPickerImob: [false, false],
      flag1: "",
      flag2: "",
      flagsValueList: [
        {value: "", text: "Todas as linhas"},
        {value: 0, text: "Somente linhas que falharam"},
        {value: 1, text: "Somente linhas aprovadas"},
      ]
    }
  },

  methods: {
    exportData() {
      return {
        calculo_id: this.$route.params.id,
        filtros: {
          obras: this.obras,
          tipologias: this.tipologias,
          dataImobilizacaoInicial: this.dataImob.inicioFormatted,
          dataImobilizacaoFinal: this.dataImob.fimFormatted,
          flags: {
            FLG_ODI_UAR_ZERO: this.flag1,
            FLG_ERR_DT_LMTO: this.flag2
          }
        }
      };
    }
  }
}

</script>

<style>

</style>